// extracted by mini-css-extract-plugin
module.exports = {"root":"SuperhostBadge_root__37uwM"};